// extracted by mini-css-extract-plugin
export default {"card-container":"Card_card-container__zI62t","card-container-centered":"Card_card-container-centered__ckFOQ"};